import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMSpaceResource from 'resources/SMSpaceResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMConst from 'lib/SMConst';
import SMORoomListView from '../rooms/SMORoomListView';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMRestClient from 'lib/SMRestClient';
import update from 'react-addons-update';
import SMOSpaceListTableRow from './SMOSpaceListTableRow';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import sprintf from 'sprintf';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import Spinner from 'components/shared/SMMaterialSpinner';
import reactMixin from 'react-mixin';

class SMOSpaceListView extends React.Component {
  
  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.state = {
      display: this.props.display,
      listItems: [],
      selectedRowIndex: -1,
      owner: this.props.owner.attributes,
      keyword: this.props.keyword, 
      pushStateUrl: "",
    };
  }
  
  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
    
    if (this.props.spaceId) {
      this.setState({display: SMConst.Display.Loading});
      SMSpaceResource.getSpace(this.props.spaceId, (space, error)=>{
        this.setState({display: SMConst.Display.Visible});
        if(error) return;
        this.canRequest = false;
        this.setState({
          keyword: space.username,
          listItems: [{space:space}],
          selectedRowIndex: 0,
          pushStateUrl: Routes.owner_dashboard_space_path(space.owner.username, space.username),
        });
      });
    } else {
      this.requestResource();
    }
    
    SMHistoryHelper.observePopState((state)=>{
      this.setState(state);
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillUpdate(nextProps, nextState) {
    $(this.refs.navigationTable).off("scroll", this.tableViewDidScroll);
    $(this.refs.mainTable).off("scroll", this.tableViewDidScroll);
  }
  
  componentDidUpdate(prevProps, prevState) {
    $(this.refs.navigationTable).on("scroll", this.tableViewDidScroll.bind(this));
    $(this.refs.mainTable).on("scroll", this.tableViewDidScroll.bind(this));
    
    let result = this.state.listItems[this.state.selectedRowIndex];
    let space = result ? result.space : null;
    if (this.state.pushStateUrl != prevState.pushStateUrl && space) {
      SMHistoryHelper.replaceState(this.state.pushStateUrl, this.state);
      SMAppHelper.setTitle(sprintf(I18n.t("dashboard.label_000084"), space.name));
    }
  }
  
  tableViewDidScroll(e){
    SMAppHelper.observeScrollToBottom(e.currentTarget, ()=>{
      if (e.currentTarget == this.refs.mainTable) {
        $(document).trigger('SMORoomListViewDidScrollBottom');
      } else if (e.currentTarget == this.refs.navigationTable) {
        this.requestResource(true);
      }
    });
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.mainTable),
        $navigationTable = $(this.refs.navigationTable),
        $navigationTableFooter = $(this.refs.navigationTableFooter);
    $navigationTable.outerHeight(this.navigationTableHeight() - $navigationTableFooter.outerHeight());
    let $subHeader = $(this.refs.headerSubNavigation);
    $mainTable.outerHeight(this.mainTableHeight() - $subHeader.outerHeight());
  }
  
  requestResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    
    let queries = {};
    if (this.state.keyword) queries["keyword"] = this.state.keyword;
    let pushStateUrl = Routes.owner_dashboard_spaces_path(this.state.owner.username, queries);
    
    if (this.currentPage != 1) queries["page"] = this.currentPage;
    
    SMOwnerResource.getSpaces(this.state.owner.id, queries, (responses, error, xhr)=>{
      this.setState({display: SMConst.Display.Visible});
      if(error || !responses) return;
      let links = SMRestClient.getLinks(xhr),
          listItems = this.state.listItems;
      if (links["next"]) {
        this.canRequest = true;
      }
      listItems = update(listItems, {$push: responses});
      
      this.currentPage++;
      let state = {listItems: listItems};
      if (!isAppend) state["pushStateUrl"] = pushStateUrl;
      this.setState(state);
    });
  }
  
  tableDidSelectRowAtIndex(rowIndex) {
    let result = this.state.listItems[rowIndex];
    let space = result ? result.space : null;
    this.setState({
      selectedRowIndex: rowIndex,
      pushStateUrl: Routes.owner_dashboard_space_path(space.owner.username, space.username),
    });
    $(this.refs.mainTable).scrollTop(0);
  }
  
  renderList() {
    if (this.state.listItems.length > 0) {
      let spaceList = [];
      for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
        let isCurrent = this.state.selectedRowIndex == rowIndex;
        let result = this.state.listItems[rowIndex];
        let space = result ? result.space : null;
        
        spaceList.push(
          <SMOSpaceListTableRow 
            key={space.id} 
            space={space}
            delegate={this}
            rowIndex={rowIndex}
            isCurrent={isCurrent} />
        );
      }
      if (this.canRequest) {
        spaceList.push(
          <p key="loading" className="js-loading-row">{I18n.t("dashboard.label_000128")}</p>
        );
      }
      return(
        <ul>
          <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {spaceList}
          </CSSTransitionGroup>
        </ul>
      );
    }
    return <p className="dashboard-sidecol__scrollarea-nodata">{I18n.t("dashboard.label_000129")}</p> ;
  }
  
  queryDidChange(e){
    let state = this.state;
    state[e.currentTarget.name] = e.currentTarget.value;
    this.setState(state);
  }
  
  formDidSubmit(e){
    this.currentPage = 1;
    this.canRequest = true;
    this.setState({
      selectedRowIndex: -1,
      listItems: [],
    });
    this.requestResource();
    e.preventDefault();
  }
  
  formDidReset(e){
    e.preventDefault();
    this.currentPage = 1;
    this.canRequest = true;
    this.setState({
      keyword: "",
      selectedRowIndex: -1,
      listItems: [],
    });
    setTimeout(()=>{
      this.requestResource();
    },1);
  }
  
  spaceDidUpdate(rowIndex, newSpace) {
    let replace = {};
    replace[rowIndex] = {space: {$set: newSpace}};
    let state = {listItems: update(this.state.listItems, replace)};
    this.setState(state);
  }
  
  spaceDidDelete(rowIndex) {
    let state = {listItems: update(this.state.listItems, {$splice: [[rowIndex, 1]]})};
    if (rowIndex == this.state.selectedRowIndex) {
      this.tableDidSelectRowAtIndex(0);
      state.display = SMConst.Display.Init;
    }
    this.setState(state);
  }
  
  trackPageEvent(e) {
    if (e.target.value == I18n.t("dashboard.label_000091")) {
      SMTrackHelper.pageEvent('od filter space_'+ this.state.keyword);
    }else {
      SMTrackHelper.pageEvent('od add space');
    }
  }
  
  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }
  
  render() {
    
    let result = this.state.listItems[this.state.selectedRowIndex];
    let space = result ? result.space : null;
    let owner = this.state.owner;
    let keyword = this.state.keyword || "";
    let mainTableDisplay, navigationTable;
    
    if (space) mainTableDisplay = SMConst.Display.Visible;
    else if (this.props.spaceId) mainTableDisplay = SMConst.Display.Hidden;
    else mainTableDisplay = SMConst.Display.Init;
    
    if (this.state.display == SMConst.Display.Loading) navigationTable = this.renderLoading();
    else navigationTable = this.renderList();
    
    return (
      <div ref="container" className="dashboard-container clearfix mb30">
        <form onSubmit={this.formDidSubmit.bind(this)} action={Routes.owner_dashboard_spaces_path(owner.username)}>
          <div ref="headerSubNavigation" className="dashboard-search">
            {I18n.t("dashboard.label_000088")}
            <input name="keyword" value={decodeURIComponent(keyword)} onChange={this.queryDidChange.bind(this)} type="text" className="dashboard-search__form mr10 ml5 w150" />
            <input onClick={this.trackPageEvent.bind(this)} className="button-blue dashboard-search__button mr5" type="submit" value={I18n.t("dashboard.label_000091")} />
            <input onClick={this.formDidReset.bind(this)} className="button-gray dashboard-search__button mr8" type="button" value={I18n.t("dashboard.label_000136")} />
          </div>
        </form>  
        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20">{I18n.t("dashboard.label_000089")}</h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            {navigationTable}
          </div>
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea">
            <a onClick={this.trackPageEvent.bind(this)} href={Routes.new_owner_dashboard_space_path(owner.username)} className="button-gray dashboard-sidecol__buttonarea-button">
              <i className="fa fa-plus"></i> {I18n.t("dashboard.label_000090")}</a>
          </div>
        </div>
        <div ref="mainTable" className="js-scroller dashboard-maincol__right">
          <SMORoomListView 
            owner={owner} 
            space={space} 
            display={mainTableDisplay} 
            delegate={this}
            selectedParentRowIndex={this.state.selectedRowIndex} />
        </div>
      </div>
    );
  }
}
SMOSpaceListView.propTypes = {
  owner: PropTypes.object.isRequired,
  spaceId: PropTypes.string,
  keyword: PropTypes.string
};
SMOSpaceListView.defaultProps = {
  display: SMConst.Display.Visible,
  page: 1,
};
reactMixin(SMOSpaceListView.prototype, SMSplitViewMixin);
export default SMOSpaceListView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceListView.jsx